import { GlobeIcon, LockIcon, UsersIcon, UsersMoreIcon } from 'shared/components/Icons';

export const shareTypesIcons = {
  PUBLIC: GlobeIcon,
  PRIVATE: LockIcon,
  CUSTOM: UsersIcon,
  FRIENDS: UsersMoreIcon,
};

export const URLS = {
  CHROME_EXTENSION: 'https://chromewebstore.google.com/detail/likiee/gmfpgnjphhmjfnkogbjheeknbinkeanh',
  FIREFOX_EXTENSION: 'https://addons.mozilla.org/addon/likiee/',
  SAFARI_EXTENSION: 'https://apps.apple.com/de/app/likiee-smart-wishlist/id6474555758',
  APP_STORE: 'https://apps.apple.com/us/app/likiee/id6478532657',
  GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=com.likiee',
  CONTACT: 'https://www.likiee.com/contact',
};
